import React, { useState } from 'react';
import { AppBar, Toolbar, Button, Typography, Box, IconButton, Menu, MenuItem, useMediaQuery } from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import Logo from "../icons/hawklogo.Component";
import { GitHub } from '@mui/icons-material';

const Header = () => {
    const navigate = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [anchorEl, setAnchorEl] = useState(null);

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleNavigation = (path) => {
        navigate(path);
        handleMenuClose();
    };

    return (
        <AppBar position="sticky" sx={{ backgroundColor: theme.palette.grey[700], top: '0px', boxShadow: 'none' }}>
            <Toolbar>
                <Box style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
                    <Logo width="46px" height="46px" />
                    <Button color="inherit" sx={{ textTransform: 'none', padding: '6px 0px' }} onClick={() => navigate('/')}>
                        HawkClient
                    </Button>
                    <Typography style={{ fontSize: '10px' }}> by Prashant Rathi</Typography>
                </Box>

                <Typography variant="h6" sx={{ flexGrow: 1 }} />

                {isMobile ? (
                    <IconButton color="inherit" onClick={handleMenuOpen}>
                        <MenuIcon />
                    </IconButton>
                ) : (
                    <>
                        <Button color="inherit" sx={{ textTransform: 'none' }} onClick={() => navigate('/download')}>
                            Download
                        </Button>
                        <Button color="inherit" sx={{ textTransform: 'none' }} onClick={() => navigate('/docs')}>
                            Docs
                        </Button>
                        <Button color="inherit" sx={{ textTransform: 'none' }} onClick={() => navigate('/support')}>
                            Support
                        </Button>
                        <Button color="inherit" sx={{ textTransform: 'none' }} onClick={() => navigate('/about')}>
                            About
                        </Button>
                        <Button color="inherit" sx={{ textTransform: 'none' }} onClick={() => navigate('/demo')}>
                            Demo
                        </Button>
                        <Button color="inherit" sx={{ textTransform: 'none' }} onClick={() => navigate('/changelog')}>
                            Changelog
                        </Button>
                        <IconButton
                            href="https://github.com/prashantrathi123/hawkClient"
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{ color: 'inherit' }}
                        >
                            <GitHub />
                        </IconButton>
                    </>
                )}

                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleMenuClose}
                >
                    <MenuItem onClick={() => handleNavigation('/download')}>Download</MenuItem>
                    <MenuItem onClick={() => handleNavigation('/docs')}>Docs</MenuItem>
                    <MenuItem onClick={() => handleNavigation('/support')}>Support</MenuItem>
                    <MenuItem onClick={() => handleNavigation('/about')}>About</MenuItem>
                    <MenuItem onClick={() => handleNavigation('/demo')}>Demo</MenuItem>
                    <MenuItem onClick={() => handleNavigation('/changelog')}>Changelog</MenuItem>
                    <MenuItem>
                        <IconButton
                            href="https://github.com/prashantrathi123/hawkClient"
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{ color: 'inherit' }}
                        >
                            <GitHub />
                        </IconButton>
                    </MenuItem>
                </Menu>
            </Toolbar>
        </AppBar>
    );
};

export default Header;
